import {
    type interfaces,
    ContainerModule,
} from '@patsnap/tahiti-core/shared/inversify';
import { UserSettingsApi } from './apis/user-settings-api';
import { UserSettingsApiImpl } from './apis/impls/user-settings-api';

export const userSettingsModule = new ContainerModule((bind: interfaces.Bind) => {
    bind(UserSettingsApi).to(UserSettingsApiImpl);
});

export * from './apis/user-settings-api';
export * from './composables/use-user-settings-state';
export * from './constants';
export * from './types';

